import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
    data: any,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as any,
    error: '',
    loading: false
}

const attestfileUploadSlice=createSlice(
    {
        name: 'fileUpload',
        initialState,
        reducers:{
            filesTobeUploaded(state,action){
                state.data=action.payload;
            }
        }, 
        
    }
);
export const { filesTobeUploaded } = attestfileUploadSlice.actions;
export default attestfileUploadSlice.reducer;
